import { Box, Text, Title } from '@nimbus-ds/components';
import ModalAside from 'App/components/lab/ModalAside';
import { useNavegate } from 'App/hooks';
import { Stack } from 'commons/components';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import { DiscountOptionList } from './DiscountOptionList';
import {
  IMPROVE_CVR_OPTIONS,
  INCREASE_AOV_OPTIONS,
  OTHER_OPTIONS,
} from './options';

interface MoreDiscountsProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MoreDiscounts({
  isOpen,
  onClose,
}: Readonly<MoreDiscountsProps>): JSX.Element {
  const t = useTranslationMarketing('moreDiscounts');
  const { goTo } = useNavegate();

  return (
    <ModalAside isOpen={isOpen} onDidDismiss={onClose} fluid>
      <Box marginLeft="6" marginRight="6">
        <Stack column align="stretch" spacing="loose">
          <Title as="h3">{t('title')}</Title>

          <Text fontSize="base" color="neutral-textHigh">
            {t('description')}
          </Text>

          <DiscountOptionList
            title={t('improveCvr.title')}
            options={IMPROVE_CVR_OPTIONS(t, goTo)}
          />

          <DiscountOptionList
            title={t('increaseAov.title')}
            options={INCREASE_AOV_OPTIONS(t, goTo)}
          />

          <DiscountOptionList
            title={t('other.title')}
            options={OTHER_OPTIONS(t, goTo)}
            displayOptionAsCard={false}
          />
        </Stack>
      </Box>
    </ModalAside>
  );
}
